import { Link, NavLink, useNavigate } from "react-router-dom";
import { Wallet, LogOut, ShieldCheck, Plus, LifeBuoy } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { fmtAZN } from "@/lib/api";
import { Logo } from "@/components/Logo";
import { Badge, useUnread } from "@/components/support/useUnread";

const navCls = ({ isActive }) =>
  `text-sm uppercase tracking-[0.18em] transition-colors ${isActive ? "text-[#FFD700]" : "text-zinc-400 hover:text-white"}`;

export const Header = () => {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const { unread, adminOpen } = useUnread(user);
  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-black/60 backdrop-blur-xl border-b border-white/10" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-3 sm:px-8 h-20 flex items-center justify-between gap-2 sm:gap-4">
        <Link to="/" data-testid="header-logo-link"><Logo compact={!!user} /></Link>
        <nav className="hidden md:flex items-center gap-8">
          <NavLink to="/" end className={navCls} data-testid="nav-games">{user ? "Oyunlar" : "Kazino"}</NavLink>
          {user === false && <a href="/#games" className={navCls({})} data-testid="nav-guest-games">Oyunlar</a>}
          {user === false && <a href="/#how" className={navCls({})} data-testid="nav-guest-how">Necə başlamaq</a>}
          {user === false && <a href="/#payments" className={navCls({})} data-testid="nav-guest-payments">Ödənişlər</a>}
          {user && <NavLink to="/wallet" className={navCls} data-testid="nav-wallet">Kassa</NavLink>}
          {user && <NavLink to="/support" className={navCls} data-testid="nav-support"><span className="relative">Dəstək<Badge n={unread} /></span></NavLink>}
          {user?.role === "admin" && <NavLink to="/admin" className={navCls} data-testid="nav-admin"><span className="relative">Admin<Badge n={adminOpen} /></span></NavLink>}
        </nav>
        <div className="flex items-center gap-1.5 sm:gap-3 shrink-0">
          {user ? (
            <>
              <div className="flex items-center gap-2 rounded-full bg-white/5 border border-[#D4AF37]/40 pl-3 sm:pl-4 pr-1 py-1 whitespace-nowrap" data-testid="header-balance">
                <Wallet size={16} className="text-[#D4AF37]" />
                <span className="font-display text-sm font-semibold text-white" data-testid="header-balance-amount">{fmtAZN(user.balance)}</span>
                <button onClick={() => nav("/wallet")} className="btn-gold rounded-full p-1.5" data-testid="header-deposit-btn" aria-label="Depozit"><Plus size={14} /></button>
              </div>
              <Link to="/support" className="relative md:hidden btn-ghost rounded-full p-2" data-testid="mobile-support-link"><LifeBuoy size={18} /><Badge n={unread} /></Link>
              {user.role === "admin" && (
                <Link to="/admin" className="md:hidden btn-ghost rounded-full p-2" data-testid="mobile-admin-link"><ShieldCheck size={18} /></Link>
              )}
              <button onClick={() => { logout(); nav("/"); }} className="btn-ghost rounded-full p-2.5 text-zinc-300" data-testid="logout-btn" aria-label="Çıxış"><LogOut size={16} /></button>
            </>
          ) : (
            <>
              <Link to="/login" className="btn-ghost rounded-full px-4 sm:px-5 py-2 text-sm" data-testid="header-login-btn">Giriş</Link>
              <Link to="/register" className="btn-gold rounded-full px-4 sm:px-5 py-2 text-sm font-semibold" data-testid="header-register-btn">Qeydiyyat</Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
};
